import React, { Component } from "react";
import "./Main.css";
import { TabStrip } from "./TabStrip";
import { isNullOrEmpty } from "./Util";
import SupportBuildings from "./SupportBuildings";

export class Support extends Component {
	constructor(props) {
		super(props);
		this.state = {
			BuildingData: null,
			CurrentBuilding: null,
			selectedTab: 0,
			DialogBuilding: null,
			DialogVisible: false,
		};

		if (!isNullOrEmpty(this.props.building)) this.getData();
		this.openDialog = this.openDialog.bind(this);
		this.getData = this.getData.bind(this);
	}
	openDialog(bldg) {
		this.setState({ DialogBuilding: bldg, DialogVisible: true });
	}

	async getData() {
		if (this.props.building) {
			const data = await fetch("Building/GetBuildingData", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				cache: "no-cache",
				body: JSON.stringify({ buildingsId: this.props.building }),
			});
			var res = await data.json();
			this.setState({ BuildingData: res, DialogVisible: false });
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.building !== this.props.building) {
			this.getData();
		}
		return false;
	}

	render() {
		var tabs = [
			{
				display: "Manage Buildings",
				component: <SupportBuildings></SupportBuildings>,
			},
			{
				display: "How-To/FAQ",
				component: <SupportBuildings></SupportBuildings>,
			},
		];

		var selectedPath = document.location.pathname.split("/");
		selectedPath = selectedPath[2];
		var selected = 0;
		switch (selectedPath) {
			case "invoices":
			case "elevators":
				selected = 1;
				break;
			case "proposals":
			case "notes":
				selected = 2;
				break;
			case "contacts":
				selected = 3;
				break;
			case "inspection":
				selected = this.props.IsClientPortal ? 3 : 4;
				break;
			default:
				break;
		}

		return (
			<div
				style={{
					backgroundColor: "#ebebeb",
					padding: "4px",
					flex: 1,
					display: "flex",
					flexDirection: "column",
					maxHeight: "100%",
				}}>
				<div
					style={{
						flex: "1 1 100%",
						backgroundColor: "white",
						display: "flex",
						overflowY: "auto",
						padding: "4px",
					}}
					className="shadow">
					<TabStrip selected={selected} tabs={tabs}></TabStrip>
				</div>
			</div>
		);
	}
}
